///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm = abcsetup.three_pm || {};
abcsetup.three_pm.price_change = abcsetup.three_pm.price_change || {};
abcsetup.three_pm.price_change.common = abcsetup.three_pm.price_change.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm.price_change.common = {
    bindFormElems: function () {
        console.log('common form elems called');

        $(document).ready(function() {
            $('#loading-text').text("");
            $('#loader').hide();
        });

        $(document).on('change keyup', 'input.price_field', function() {

            $(this).parent().find('span').hide();
            $('#comment-info').hide();

            let current = parseFloat($(this).data('current'));
            let old_cost_plus_extra_percent = current + parseFloat(current * 0.15); //15% added to original value
            let old_cost_minus_extra_percent = current - parseFloat(current * 0.15); //15% subtracted to original value
            let value = parseFloat($(this).val());
            let span = $(this).parent().find('span');


            if (value > 0) {
                if (value > parseFloat(old_cost_plus_extra_percent)) {
                    span.text('There is over a 15% increase in price.');
                    span.show();
                } else if (value < parseFloat(old_cost_minus_extra_percent)) {
                    span.text('There is over a 15% decrease in price.');
                    span.show();
                } else if (value == current) {
                    span.text('Note these are the same price.');
                    span.show();
                } else {
                    span.text('');
                }
            }

            /**
             * Displays arrows whether the price is > or < than the old price
             */
            if (value > current) {
                span.prepend('<i class="fas fa-arrow-up"></i> ');
                span.show();
            } else if (current > value) {
                span.prepend('<i class="fas fa-arrow-down"></i> ');
                span.show();
            } else {
                span.prepend('<i class="fas fa-equals"></i> ');
            }

        });

        //$('input.price_field').trigger('change');

        $('#approveAll').on('click', function() {
            $(".radio-approve").prop( "checked", true);
            clearDefaultRejectComment()
            checkEnabled();
        });

        $('#rejectAll').on('click', function() {
            $(".radio-reject").prop( "checked", true);
            $('#comment-info').show();
            checkEnabled();
        });

        $('#clearAll').on('click', function() {
            $('.radio-reject, .radio-approve').each( function() {
                if ($(this).is(':enabled')) {
                     $(this).prop("checked", false );
                }
            });
            checkEnabled();
            clearDefaultRejectComment();
        });

        $('#reject-all-comment-box').on('change', (event) => {
            Array.from(comment_boxes).forEach(function (box) {
                box.value = document.getElementById('reject-all-comment-box').value;
            });
        });

        //disabled by default
        $('#submit_button').prop("disabled", true);

        $('#submit_button').on('click', function(e) {
            $('#loading-text').append('Please Wait! ');
            $('#loader').show();
            setTimeout(() => {
                $('#submit_button').prop("disabled", true);
            }, 500);
        });

        let radio_buttons = document.querySelectorAll('input[type=radio]');
        let comment_boxes = document.getElementsByTagName('textarea');

        function checkEnabled() {
            //only 1 of the 2 available radio buttons will ever be clicked. So we only get half of the total
            let number_of_radio_buttons = document.querySelectorAll('input[type=radio]').length / 2;
            let radio_buttons_checked = document.querySelectorAll('input[type=radio]:checked').length;

            if (number_of_radio_buttons == radio_buttons_checked) {
                $('#submit_button').prop("disabled", false);
            } else {
                $('#submit_button').prop("disabled", true);
            }
        }

        function clearDefaultRejectComment() {
            Array.from(comment_boxes).forEach(function (box) {
                box.value = '';
            });
            document.getElementById('reject-all-comment-box').value = '';
            $('#comment-info').hide();
        }

        radio_buttons.forEach(radio => {
            radio.addEventListener('change', checkEnabled);
        });

        $('#load-more-button').on('click', function (e) {
            let new_count = parseFloat($('#load-count').val()) + parseFloat(10);
            $('#load-count').val(new_count);
            hideRows(true);
            for (let i = (new_count - 10); i < new_count; i++) {
                $('#'+i).removeClass('hide');
            }
            triggerInputs();
        });

        $('#load-all-button').on('click', function (e) {
            $("table > tbody > tr").each(function () {
                $(this).show();
            });
        })

        $('#reset-load-more-button').on('click', function (e) {
            $('#load-count').val(10);
            hideRows()
        });

        function hideRows(show = false) {
            $("table > tbody > tr").each(function () {
                if (show) {
                    $(this).show();
                }
                if (parseFloat($(this).attr('id')) > parseFloat($('#load-count').val()) - 1) {
                    $(this).hide();
                }
            });
        }

        function triggerInputs() {
            $("table > tbody > tr.not-rendered").each(function () {
                if (!$(this).hasClass('hide')) {
                   $(this).find('input.price_field').trigger('change');
                   $(this).removeClass('not-rendered');
                }
            });
        }

        triggerInputs();
    }
}
